import { render, staticRenderFns } from "./MyAnswer.vue?vue&type=template&id=44eb0b01"
import script from "./MyAnswer.vue?vue&type=script&lang=js"
export * from "./MyAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports